export default "__VITE_ASSET__BiPT5xp1__"